import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";
import { Button } from "./button";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    title?:string;
    img?:any;
    badge?:boolean;
    onClick?:any;
}

export function ProductCard({ title , img , badge , onClick}: Props): ReactElement {

    return (
        <div className="product-card">
            <img src={img} className="product-card-img" alt="هامرز"/>
          <div className="product-card-content">
          <span className="title">{title}</span>
          {badge ? 
          <div className="badge">بیمه نامه فعال</div>
          
        :
        
        
          <Button myStyle="button" title="شرایط بیمه نامه" onClick={()=>
              window.open(
                  `${onClick}`,
                  '_blank' 
                )
          }
          />
        }
          </div>
        </div>
    )
}

export default ProductCard;